import { Link, Outlet, useNavigate } from "react-router-dom";
import { clearJwt, getRole, getValidJwt } from "@/lib/auth";
import { Button } from "./ui/button";

export function Layout() {
  const navigate = useNavigate();
  const isAuth = !!getValidJwt();
  const role = getRole();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b bg-card">
        <div className="container mx-auto flex h-12 items-center justify-between px-4">
          <Link to="/" className="font-semibold text-sm">IP 分析</Link>
          {isAuth && (
            <nav className="flex items-center gap-2 text-sm">
              <Link to="/" className="hover:underline">トップ</Link>
              {role === "admin" && <Link to="/admin/users" className="hover:underline">管理</Link>}
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  clearJwt();
                  navigate("/login", { replace: true });
                }}
              >
                ログアウト
              </Button>
            </nav>
          )}
        </div>
      </header>
      <main className="flex-1 container mx-auto px-4 py-6"><Outlet /></main>
      <footer className="border-t bg-muted/40 text-xs text-muted-foreground">
        <div className="container mx-auto px-4 py-2">最終更新: -</div>
      </footer>
    </div>
  );
}
